import { render, staticRenderFns } from "./BodyTypeModal.vue?vue&type=template&id=88f7617e&scoped=true"
import script from "./BodyTypeModal.vue?vue&type=script&lang=js"
export * from "./BodyTypeModal.vue?vue&type=script&lang=js"
import style0 from "./BodyTypeModal.vue?vue&type=style&index=0&id=88f7617e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f7617e",
  null
  
)

export default component.exports